import { render, staticRenderFns } from "./FeatureStatus.vue?vue&type=template&id=68360a29&scoped=true&lang=pug&"
import script from "./FeatureStatus.vue?vue&type=script&lang=js&"
export * from "./FeatureStatus.vue?vue&type=script&lang=js&"
import style0 from "./FeatureStatus.vue?vue&type=style&index=0&id=68360a29&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68360a29",
  null
  
)

export default component.exports